import styled from 'styled-components';
import { Box } from '@telus-uds/components-web';

export const Container = styled.div`
  width: 1200px;
  margin: 0 auto;
  padding: 1rem;
`;

export const Wrapper = styled(Box)`
  width: 1200px;
  margin: 2rem auto;
  margin-bottom: 10rem;
  border: 1px solid rgb(227, 227, 227);
  box-shadow: rgb(227 227 227) 1px 1px 9px 4px;
  padding: 2rem;
`;

export const Title = styled(Box)`
  color: #2a2c2e;
  font-size: 2em;
  padding: 2rem 0;
`;

export const BoxWrapper = styled.div`
  display: flex;
  padding: 1rem 0;
`;
